const trackingSelector = (state) => state.tracking;

const trackingAbTestSelector = (state) => trackingSelector(state).abTest;

export { trackingAbTestSelector };
